import { render, staticRenderFns } from "./fields-basic.vue?vue&type=template&id=152de3f7&scoped=true&"
import script from "./fields-basic.vue?vue&type=script&lang=js&"
export * from "./fields-basic.vue?vue&type=script&lang=js&"
import style0 from "./fields-basic.vue?vue&type=style&index=0&id=152de3f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152de3f7",
  null
  
)

export default component.exports